import { CandleApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';
import { createQuery } from 'utils/queries';

import { Axios } from '../../axios';

import { CandleQuery } from './types';

export class VoladeumCandles extends Axios {
  async list(pair_id: string, query: CandleQuery = {}): Promise<VoladeumResponse<CandleApi[]>> {
    const res = await this.get<VoladeumResponse<CandleApi[]>>(
      `/v1/pairs/${pair_id}/candles${createQuery(query)}`
    );

    return {
      success: res.success,
      error: res.error,
      data: res.data,
    };
  }
}
